import { Table } from '@tanstack/react-table';
import { Row, RowSelectionState } from '@tanstack/table-core';
import { useState } from 'react';

/**
 * Hook to manage row selection state for statistic time card table
 * @param getTable function that returns the table instance
 * @param onSelectionChange callback function that will be called when selection changes
 * @returns array containing selection state and handler function
 */
export function useStatisticTimeCardTableRowSelection<T>(
  getTable: () => Table<T>,
  onSelectionChange?: (selectedRows: Row<T>[]) => void
) {
  const [selectionState, setSelectionState] = useState<RowSelectionState>({});

  const handleSelectionChange = (
    updaterOrValue:
      | RowSelectionState
      | ((state: RowSelectionState) => RowSelectionState)
  ) => {
    const newValue =
      typeof updaterOrValue === 'function'
        ? updaterOrValue(selectionState)
        : updaterOrValue;

    const selectedRows: Row<T>[] = [];

    for (const [id, selected] of Object.entries(newValue)) {
      if (selected) {
        const row = getTable().getRow(id);
        if (row) {
          selectedRows.push(row);
        }
      }
    }

    onSelectionChange?.(selectedRows);
    setSelectionState(newValue);
  };

  return [selectionState, handleSelectionChange] as const;
}
